import { IReportTemplate } from '@opengov/reporting-types';
import { castDraft, produce } from 'immer';

import { composeStateMachine } from '../../../module';

export const ReportTemplateInitialState = Object.freeze({
  reportTemplates: [] as IReportTemplate[],
  loadingReportTemplates: {
    active: false,
    error: null
  },
  currentTemplate: null,
  currentLens: null,
  hasFetchedEntityLenses: false,
  queryString: null // to support route changes
});

export const reportTemplateState = composeStateMachine('report-templates', ReportTemplateInitialState, (compose) => ({
  loadReportTemplatesRequest: compose.payloadlessAction((state) =>
    produce(state, (draft) => {
      draft.loadingReportTemplates.active = true;
    })
  ),
  loadReportTemplatesSuccess: compose.action((state, payload: { templates: IReportTemplate[] }) =>
    produce(state, (draft) => {
      draft.loadingReportTemplates = { active: false, error: null };
      draft.reportTemplates = castDraft(payload.templates);
    })
  ),
  loadReportTemplatesFailure: compose.action((state, error: any) =>
    produce(state, (draft) => {
      draft.loadingReportTemplates.error = error;
    })
  ),
  setCurrentTemplate: compose.action((state, template) =>
    produce(state, (draft) => {
      draft.currentTemplate = template;
    })
  ),
  setCurrentLens: compose.action((state, lens) =>
    produce(state, (draft) => {
      draft.currentLens = lens;
    })
  ),
  storeQueryString: compose.action((state, queryString) =>
    produce(state, (draft) => {
      draft.queryString = queryString;
    })
  ),
  setHasFetchedEntityLenses: compose.payloadlessAction((state) =>
    produce(state, (draft) => {
      (draft.hasFetchedEntityLenses as boolean) = true;
    })
  )
}));

export const {
  actions: reportTemplateActions,
  actionCreators: reportTemplateActionCreators,
  selector: reportTemplateSelector,
  reducer: reportTemplateReducer
} = reportTemplateState;
